import React, { useContext } from "react";

import { useTranslation } from "react-i18next";

import { FormInputFieldCurrency } from "@components-shared/desktop/inputs";
import { LIMITS_CONSTANTS } from "@services/account-settings/MyLimitsConstants";
import { DepositContext } from "@state/context/payment/DepositContext";
import { LimitType } from "@utils/limits/limitType";
import { observer } from "mobx-react";

export default observer(function DepositLimitWeeklyLimit() {
	const depositStore = useContext(DepositContext);

	const { t } = useTranslation("my-limits");

	if (
		depositStore.depositLimitStore.limitData?.userLimits[0]
			?.gamingLimitDuration.abrv !== LimitType.WEEKLY_LIMIT
	) {
		return null;
	}

	return (
		<>
			<div className="title--secondary">
				{t(
					`${depositStore.depositLimitStore.limitData?.userLimits[0].gamingLimitDuration.name}`
				)}
			</div>

			<div className="form__group u-mar--bottom--4">
				<FormInputFieldCurrency
					label={t("LIMIT_AMOUNT_LABEL")}
					name="amount"
					type="number"
					step={".01"}
					className="form__field"
					placeholder={t("LIMIT_AMOUNT_PLACEHOLDER")}
					validate={{
						isNotNegative: (value: string) =>
							Number(value) > 0 ||
							t("ONE_OR_GREATER", {
								0: 0,
							}),
						isMaxLengthReached: (value: string) =>
							Number(value) <=
								LIMITS_CONSTANTS.GENERAL_MAX_AMOUNT ||
							t("LIMIT_EXCEEDS_MAX_VALUE"),
					}}
					required
				/>
			</div>
		</>
	);
});
